import React from 'react';

import { Icon } from 'components';

import backIcon from 'assets/svg/arrow-left.svg';
import './backLink.scss';

interface Props {
    title: JSX.Element | string;
    onClick: VoidFn;
}

const BackLink: React.FC<Props> = ({ title, onClick }) => (
    <div styleName="container" onClick={onClick}>
        <div styleName="back">
            <Icon glyph={backIcon} />
        </div>

        {title}
    </div>
);

export default React.memo(BackLink);
